<template>
  <v-ons-page class="l-content l-document">
    <div class="container">
      <v-ons-button v-for="(region, index) in regions" :key="index" modifier="large" @click="view(region);" v-if="region.name">
        <i class="fas fa-map-marker-alt"></i>
        {{ region.name }}
        <i class="fas fa-map-marker-alt absoluteIcon"></i>
      </v-ons-button>
    </div>
  </v-ons-page>
</template>

<script>
  import EmergencyRegion from './EmergencyRegion.vue';

  export default {
    data () {
      return {
        regions: emergency_contacts
      };
    },
    methods: {
      view(region) {
        self = this;
        this.$store.commit('navigator/push', {
          extends: EmergencyRegion,
          data() {
            return {
              title: region.name,
              region: self.regions.common
            };
          }
        });
      }
    }
  };
</script>


// WEBPACK FOOTER //
// Emergency.vue?0b06b2eb